import React, { useState } from "react";
import { useL } from "@/lib/useL";
import { BookOpen, X } from "lucide-react";
import { KDP_URL, KDP_KINDLE_URL, KDP_TITLE } from "@/lib/kdpConfig";

const KEY = "sux1_dash_book_hidden";

// Discreet dismissable card linking to the Amazon book (paperback + Kindle).
export function DashboardBookCard() {
  const L = useL();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  if (hidden || !KDP_URL) return null;
  const hide = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  const link = "font-mono uppercase tracking-[0.12em] text-[10px] text-[#002FA7] underline underline-offset-4 hover:no-underline";
  return (
    <div data-testid="dash-book-card" className="mx-6 md:mx-8 lg:mx-10 mt-6 flex items-center gap-3 border border-border px-4 py-3 text-sm">
      <BookOpen className="w-4 h-4 text-[#002FA7] shrink-0" />
      <div className="flex-1 min-w-0 flex flex-wrap items-center gap-x-4 gap-y-1">
        <span><b>{KDP_TITLE}</b> <span className="text-muted-foreground">{L("· le livre de l'auteur de SUX1", "· the book by SUX1's author (in French)")}</span></span>
        <a href={KDP_URL} target="_blank" rel="noopener noreferrer" className={link} data-testid="dash-book-paperback">{L("Broché", "Paperback")}</a>
        {KDP_KINDLE_URL && <a href={KDP_KINDLE_URL} target="_blank" rel="noopener noreferrer" className={link} data-testid="dash-book-kindle">Kindle</a>}
      </div>
      <button type="button" onClick={hide} aria-label={L("Masquer", "Hide")} data-testid="dash-book-hide" className="text-muted-foreground hover:text-foreground shrink-0"><X className="w-4 h-4" /></button>
    </div>
  );
}
